module.exports = {
      id: "cinema-usage",
      viewBox: "0 0 26.501 25.377",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#cinema",
      toString: function () {
        return this.url;
      }
    }